import { ReactNode } from 'react'
import { useField } from 'formik'
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
  SelectProps,
} from '@ritualco/jutsu'

export type FormikSelectProps = {
  label?: ReactNode
  name: string
  isDisabled?: boolean
} & SelectProps

export const FormikSelect = ({
  label,
  isDisabled = false,
  isRequired = false,
  ...props
}: FormikSelectProps) => {
  const [field, { error, touched }] = useField(props.name)
  return (
    <FormControl
      id={props.name}
      isInvalid={!!error && touched}
      isDisabled={isDisabled}
      isRequired={isRequired}
    >
      {label && <FormLabel>{label}</FormLabel>}
      <Select size="lg" isDisabled={isDisabled} {...field} {...props} />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  )
}
